import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const MiniCartProductDefaultProps = {
  ...ClassNameDefaultProps,
  product: {},
  onQuantityChange: () => {},
  isLoadingDelete: false,
  onDeleteCartItem: () => {},
};

export const MiniCartProductPropTypes = {
  ...ClassNamePropTypes,
  product: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    sku: PropTypes.string,
    supplier_code: PropTypes.string,
    quantity: PropTypes.number,
    price: PropTypes.number,
    line_subtotal: PropTypes.number,
    product: PropTypes.shape({
      name: PropTypes.string,
      image: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
      }),
      price_and_stock: PropTypes.shape({
        stocks: PropTypes.arrayOf(
          PropTypes.shape({
            available: PropTypes.number,
          }),
        ),
        price: PropTypes.shape({
          discount_price: PropTypes.number,
        }),
        sales_packaging: PropTypes.number,
        split_packaging: PropTypes.bool,
        sale_unit: PropTypes.string,
      }),
    }),
  }),
  onQuantityChange: PropTypes.func,
  isLoadingDelete: PropTypes.bool,
  onDeleteCartItem: PropTypes.func,
};
